import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Edit_MRM.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

function Edit_MRM({ onCancel,handleClose }) {
  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">
          {/* Document Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Document Name</Form.Label>
              <Form.Control placeholder="Enter Name Of Document" />
            </Form.Group>
          </div>

          {/* Start Date */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Start Date Of Last Internal Audit</Form.Label>
              <Form.Control type="date" />
            </Form.Group>
          </div>

          {/* End Date */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>End Date Of Last Internal Audit</Form.Label>
              <Form.Control type="date" />
            </Form.Group>
          </div>

          {/* Action Taken */}
          <div className="col-md-12">
            <Form.Group className="form_group">
              <Form.Label>Action Taken:</Form.Label>

              <div className="row action_taken_group">
                <div className="col-md-4">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Pending / Forwarded to Regulator/Company Your complaint has been successfully registered & sent to the concerned party for resolution."
                  />
                </div>

                <div className="col-md-4">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Action Taken Report (ATR) Received The company or agency has submitted their report on what action they have taken."
                  />
                </div>

                <div className="col-md-4">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Root Cause The Company Or Agency Has Submitted Their Report On What Action They Have Taken."
                  />
                </div>

                <div className="col-md-4 mt-2">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Resolved / Satisfied The issue has been sorted out to your satisfaction (often after you confirm the resolution)."
                  />
                </div>

                <div className="col-md-4 mt-2">
                  <Form.Check
                    type="radio"
                    name="actionTaken"
                    label="Disposed The case is closed. This could be because it was resolved, was not taken up, or you did not respond to an inquiry."
                  />
                </div>
              </div>
            </Form.Group>
          </div>

          {/* Remark */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control placeholder="Enter Remark" />
            </Form.Group>
          </div>
        </div>
        <div className="dashed_border_holder"></div>
        <div className="row">
          <div className="note_text_hodler">
            <p className="red_text">
              To continue the process, please upload your evidence at your
              earliest convenience.
            </p>
          </div>
          {/* Attach File */}
          <div className="col-md-4">
            <Form.Group className="form_group file_field">
              <Form.Label>Attach File</Form.Label>
              <div className="absolute_fields">
                <Form.Control placeholder="Upload File" disabled />
                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                </div>
              </div>
            </Form.Group>
          </div>
        </div>

        {/* Action Buttons */}
          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
      </div>
    </section>
  );
}

export default Edit_MRM;
